{
  "nl": {
    "groupJoinForm": {
      "label": "8-cijferige activeringscode",
      "placeholder": "Code invoeren...",
      "submit": "Licentie activeren",
      "error": "De ingevoerde code is ongeldig.",
      "invalidFormat": "Voer een geldige 8-cijferige code in.",
      "alreadyMember": "Je bent al lid van deze groep."
    }
  }
}
